import React from 'react';

const ModalCloseIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.4'
        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
        fill='#5B91F5'
      />
      <path
        d='M13.0594 11.9999L15.3594 9.69986C15.6494 9.40986 15.6494 8.92986 15.3594 8.63986C15.0694 8.34986 14.5894 8.34986 14.2994 8.63986L11.9994 10.9399L9.69937 8.63986C9.40937 8.34986 8.92937 8.34986 8.63938 8.63986C8.34938 8.92986 8.34938 9.40986 8.63938 9.69986L10.9394 11.9999L8.63938 14.2999C8.34938 14.5899 8.34938 15.0699 8.63938 15.3599C8.78938 15.5099 8.97937 15.5799 9.16937 15.5799C9.35937 15.5799 9.54937 15.5099 9.69937 15.3599L11.9994 13.0599L14.2994 15.3599C14.4494 15.5099 14.6394 15.5799 14.8294 15.5799C15.0194 15.5799 15.2094 15.5099 15.3594 15.3599C15.6494 15.0699 15.6494 14.5899 15.3594 14.2999L13.0594 11.9999Z'
        fill='#5B91F5'
      />
    </svg>
  );
};

export default ModalCloseIcon;
